var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifyingGlassNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_Zoom_1399790") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Games/Questions-options",
    transform: "translate(-1100.000000, -365.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section/TableBox",
    transform: "translate(340.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(50.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 181.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dropdown-Options",
    transform: "translate(687.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Zoom_1399790",
    transform: "translate(23.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6608613,13.2643951 L10.6878166,9.29135035 C12.5759963,6.63609766 11.946603,2.97774952 9.29135035,1.08956984 C6.63609766,-0.798609848 2.97774952,-0.169216619 1.08956984,2.48603606 C-0.798609848,5.14128875 -0.169216619,8.79963689 2.48603606,10.6878166 C4.53156406,12.1432884 7.24582235,12.1432884 9.29135035,10.6878166 L13.2643951,14.6608613 C13.6184288,15.0739006 14.247822,15.1132377 14.6608613,14.759204 C15.0739006,14.4051703 15.1132377,13.7757771 14.759204,13.3627378 C14.7395355,13.3430693 14.7001984,13.3037322 14.6608613,13.2643951 Z M2.60404729,9.17333912 C0.794541762,7.36383358 0.794541762,4.41355283 2.60404729,2.60404729 C4.41355283,0.794541762 7.36383358,0.794541762 9.17333912,2.60404729 C10.9828446,4.41355283 10.9828446,7.36383358 9.17333912,9.17333912 C7.38350212,10.9828446 4.47255844,11.0025132 2.64338437,9.21267619 C2.64338437,9.19300765 2.62371583,9.19300765 2.60404729,9.17333912 Z",
    id: "Shape"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlassNew);
export default __webpack_public_path__ + "static/media/magnifying-glass-new.0cfb1bfb28cff2ba25b8a28b7ef4721b.svg";
export { ForwardRef as ReactComponent };